const getCookie = function getCookieValue(key) {
  const cookieArray = document.cookie.split("; ");

  if (cookieArray.find((row) => row.startsWith(`${key}=`))) {
    return cookieArray.find((row) => row.startsWith(`${key}=`)).split("=")[1];
  }

  return false;
};

export default getCookie;
